export const RTL_LOCALES = [/* 'العربية', Arabic */
'ar', /* Aramaic */
'arc', /* 'بلوچی مکرانی', Southern Balochi */
'bcc', /* 'بختياري', Bakthiari */
'bqi', /* 'Soranî / کوردی', Sorani */
'ckb', /* Dhivehi */
'dv', /* 'فارسی', Persian */
'fa', /* 'گیلکی', Gilaki */
'glk', /* 'עברית', Hebrew */
'he', /* 'Kurdî / كوردی', Kurdish */
'ku', /* 'مازِرونی', Mazanderani */
'mzn', /* 'پنجابی', Western Punjabi */
'pnb', /* 'پښتو', Pashto, */
'ps', /* 'سنڌي', Sindhi */
'sd', /* 'Uyghurche / ئۇيغۇرچە', Uyghur */
'ug', /* 'اردو', Urdu */
'ur', /* 'ייִדיש', Yiddish */
'yi'];
//# sourceMappingURL=rtl-locales.js.map